import { useCallback, useRef, useState } from "react";

import { countsAsDecline } from "../forms/Payment/paymentFailures";

// Per IA session, in sessionStorage, so a reload in the same tab keeps the
// count. The key is deliberately not the old `paymentFailureCount:` one: that
// count included tokenize and store failures, so it is not a decline count.
const storageKey = (iaSession) => `paymentDeclineCount:${iaSession}`;

const readStoredDeclineCount = (iaSession) => {
  try {
    return Number(window.sessionStorage.getItem(storageKey(iaSession))) || 0;
  } catch (e) {
    return 0;
  }
};

// Owns the card step's failure state. `reportPaymentFailure(kind, reason)`
// records what went wrong for the message, and bumps `declineCount` only for
// an issuer decline (see countsAsDecline).
const usePaymentFailures = (iaSession) => {
  const [paymentError, setPaymentError] = useState(null);
  // A ref alongside the state so two reports in the same tick (or a handler
  // holding a stale closure) still increment from the latest value.
  const declineCountRef = useRef(null);
  if (declineCountRef.current === null) {
    declineCountRef.current = readStoredDeclineCount(iaSession);
  }
  const [declineCount, setDeclineCount] = useState(declineCountRef.current);

  const reportPaymentFailure = useCallback(
    (kind, reason) => {
      console.warn(`[payment] ${kind}: ${reason || "unknown reason"}`);
      setPaymentError({ kind, reason });
      if (!countsAsDecline(kind)) return;

      const next = declineCountRef.current + 1;
      declineCountRef.current = next;
      try {
        window.sessionStorage.setItem(storageKey(iaSession), String(next));
      } catch (e) {}
      setDeclineCount(next);
    },
    [iaSession]
  );

  return { paymentError, declineCount, reportPaymentFailure };
};

export default usePaymentFailures;
